import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/feature-pages.css'
import './styles/ui-controls.css'
import axios from 'axios'
import { demoReadOnlyError, isDemoReadRequest, isDemoRestriction } from './utils/demoMode'
import { normalizeApiError } from './utils/apiErrors'

Vue.config.productionTip = false

window.addEventListener('error', event => {
  if (event && event.message === 'Script error.' && !event.filename) {
    event.preventDefault()
  }
})

const APP_NAME = process.env.VUE_APP_NAME || 'ChipsNet'
const API_PORT = process.env.VUE_APP_API_PORT || '8001'
const DEFAULT_API_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : `${window.location.protocol}//${window.location.hostname}:${API_PORT}`

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || DEFAULT_API_URL
})
api.demoReadOnly = false

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (!token) api.demoReadOnly = false
  if (api.demoReadOnly && !isDemoReadRequest(config)) return Promise.reject(demoReadOnlyError(config))
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

let authRedirecting = false

api.interceptors.response.use(
  response => {
    const path = String(response.config.url || '').split('?')[0].replace(/\/$/, '')
    if (path.endsWith('/users/me') || path.endsWith('/auth/login')) api.demoReadOnly = response.data.role === 'demo'
    return response
  },
  error => {
    normalizeApiError(error)
    const status = error?.response?.status
    const url = String(error?.config?.url || '')
    const isAuthApi = url.includes('/auth/login') || url.includes('/auth/register')

    if (status === 401 && !isAuthApi && !isDemoRestriction(error)) {
      error.__authHandled = true
      if (!authRedirecting) {
        authRedirecting = true
        api.demoReadOnly = false
        localStorage.clear()
        Message.closeAll()
        Message.warning('登录已过期，请重新登录')
        if (router.currentRoute.name !== 'Login') {
          const currentPath = router.currentRoute && router.currentRoute.fullPath
          router.replace({
            name: 'Login',
            query: currentPath && currentPath !== '/' ? { redirect: currentPath } : undefined
          })
        }
        setTimeout(() => {
          authRedirecting = false
        }, 1500)
      }
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$api = api
Vue.prototype.$appName = APP_NAME
Vue.use(ElementUI)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
